<script setup>
  defineOptions({
    name: "AiStatusBadge",
  });

  const props = defineProps({
    status: {
      type: String,
      required: true,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: null,
    },
  });

  const statusConfig = {
    queuing: {classes: "bg-gray-100 text-gray-600", icon: "…"},
    pending: {classes: "bg-yellow-100 text-yellow-800", icon: "⏳"},
    running: {classes: "bg-blue-100 text-blue-800", icon: "⚙"},
    completed: {classes: "bg-green-100 text-green-800", icon: "✓"},
    failed: {classes: "bg-red-100 text-red-800", icon: "✗"},
    timeout: {classes: "bg-orange-100 text-orange-800", icon: "⏱"},
    aborted: {classes: "bg-gray-200 text-gray-700", icon: "—"},
  };

  function getConfig() {
    return statusConfig[props.status] ?? {classes: "bg-gray-100 text-gray-600", icon: "?"};
  }
</script>

<template>
  <span :class="getConfig().classes" class="rounded px-1.5 py-0.5 text-xs font-medium">
    <template v-if="iconOnly">{{ getConfig().icon }}</template>
    <template v-else>{{ getConfig().icon }} {{ prefix ? `${prefix} ` : "" }}{{ status }}</template>
  </span>
</template>
